<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-cog"></i></span>{{ 'FaqMaintenance.FaqEdit.EditHeader' | translate }}
  </h1>
  <p-card>
    <form [formGroup]="editForm">
      <div class="p-fluid">

        <div class="field grid">
          <label>{{ 'FaqMaintenance.FaqEdit.Question' | translate}}</label>
          <textarea pInputTextarea formControlName="question" [rows]="5" [cols]="30" [autoResize]="true"></textarea>
        </div>

        <div class="field grid">
          <label class="label-space">{{ 'FaqMaintenance.FaqEdit.Facility' | translate}}</label>
          <laas-facility-dropdown 
            formControlName="facility"
            [divClass]="'multiSelect-width'" 
            [isMultiple]="true" 
            [showFilter]="true"
            [showToggleAll]="true">
          </laas-facility-dropdown>
        </div>

        <div class="field grid">
          <label class="label-space">{{ 'NotificationSubscribtion.Form.Tenant' | translate}}</label>
          <p-multiSelect formControlName="tenantList" [options]="tenantOptions" [filter]="true"
              class="multiSelect-width" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
          </p-multiSelect>
        </div>

        <div class="field grid">
          <label>{{ 'FaqMaintenance.FaqEdit.IsActivated' | translate}}</label>
          <div class="formgroup-inline ml-2">
            <p-radioButton formControlName="isActivated" name="isActivated" value="1" label="Y"></p-radioButton>
            <p-radioButton formControlName="isActivated" name="isActivated" value="0" label="N" class="ml-2"></p-radioButton>
          </div>
        </div>

      </div>


      <p-editor formControlName="answer" [style]="{'height':'600px'}">
        <ng-template pTemplate="header">
        </ng-template>
      </p-editor>

      <div class="grid mt-2">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtnClick()"></button>
          <button pButton pRipple label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}"  class="p-button-secondary ml-2" (click)="goToLastPage()"></button>
        </div>
      </div>
    </form>
  </p-card>
</div>
